<ng-container *ngIf="readOnly; else editable">
  <ngx-monaco-editor
    [options]="editorOptions"
    [(ngModel)]="code"
    (onInit)="onEditorInit($event)"
  ></ngx-monaco-editor>
</ng-container>
<ng-template #editable>
  <ngx-monaco-editor
    [options]="editorOptions"
    [(ngModel)]="code"
    (change)="onCodeChange()"
    (mouseleave)="onCodeChange()"
    (onInit)="onEditorInit($event)"
  ></ngx-monaco-editor>
</ng-template>
